"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultGroup = void 0;
exports.defaultGroup = {
    id: null,
    tenantId: "",
    groupName: "",
    groupType: "",
    active: false
};
//# sourceMappingURL=groups.js.map